/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './**/*.{js,jsx,ts,tsx,vue,html,css,scss,sass,less,styl,md,mdx,svelte,astro}',
    '!./node_modules/**/*',
  ],
  theme: {
    extend: {
      colors: {
        // Body colors
        body: 'var(--color-body)',
        'body-light': 'var(--color-body-light)',
        'body-feint': 'var(--color-body-feint)',
        brand: 'var(--color-brand)',
        'brand-dark': 'var(--color-brand-dark)',
        grey: 'var(--color-grey)',
        white: 'var(--color-white)',
        'border-default': 'var(--color-border-default)',
        'border-dark': 'var(--color-border-dark)',
        overlay: 'var(--color-overlay)',
        'white-light': 'var(--color-white-light)',

        // Status colors
        negative: 'var(--color-negative)',
        'negative-bg': 'var(--color-negative-bg)',
        critical: 'var(--color-critical)',
        'critical-bg': 'var(--color-critical-bg)',
        positive: 'var(--color-positive)',
        'positive-bg': 'var(--color-positive-bg)',
        information: 'var(--color-information)',
        'information-bg': 'var(--color-information-bg)',

        // Mono colors
        mono: {
          '000': 'var(--color-mono-000)',
          100: 'var(--color-mono-100)',
          200: 'var(--color-mono-200)',
          300: 'var(--color-mono-300)',
          400: 'var(--color-mono-400)',
          500: 'var(--color-mono-500)',
          600: 'var(--color-mono-600)',
          700: 'var(--color-mono-700)',
          800: 'var(--color-mono-800)',
          900: 'var(--color-mono-900)',
          'tr-100': 'var(--color-mono-tr-100)',
          'tr-200': 'var(--color-mono-tr-200)',
          'tr-300': 'var(--color-mono-tr-300)',
          'tr-400': 'var(--color-mono-tr-400)',
          'tr-500': 'var(--color-mono-tr-500)',
          'tr-600': 'var(--color-mono-tr-600)',
          'tr-700': 'var(--color-mono-tr-700)',
          'tr-800': 'var(--color-mono-tr-800)',
          'tr-900': 'var(--color-mono-tr-900)',
        },

        // Blue colors
        blue: {
          100: 'var(--color-blue-100)',
          200: 'var(--color-blue-200)',
          300: 'var(--color-blue-300)',
          400: 'var(--color-blue-400)',
          500: 'var(--color-blue-500)',
          600: 'var(--color-blue-600)',
          700: 'var(--color-blue-700)',
          800: 'var(--color-blue-800)',
          900: 'var(--color-blue-900)',
        },

        // Red colors
        red: {
          100: 'var(--color-red-100)',
          200: 'var(--color-red-200)',
          300: 'var(--color-red-300)',
          400: 'var(--color-red-400)',
          500: 'var(--color-red-500)',
          600: 'var(--color-red-600)',
          700: 'var(--color-red-700)',
          800: 'var(--color-red-800)',
          900: 'var(--color-red-900)',
        },

        // Green colors
        green: {
          100: 'var(--color-green-100)',
          200: 'var(--color-green-200)',
          300: 'var(--color-green-300)',
          400: 'var(--color-green-400)',
          500: 'var(--color-green-500)',
          600: 'var(--color-green-600)',
          700: 'var(--color-green-700)',
          800: 'var(--color-green-800)',
          900: 'var(--color-green-900)',
        },

        // Yellow colors
        yellow: {
          100: 'var(--color-yellow-100)',
          200: 'var(--color-yellow-200)',
          300: 'var(--color-yellow-300)',
          400: 'var(--color-yellow-400)',
          500: 'var(--color-yellow-500)',
          600: 'var(--color-yellow-600)',
          700: 'var(--color-yellow-700)',
          800: 'var(--color-yellow-800)',
          900: 'var(--color-yellow-900)',
        },

        // Pink colors
        pink: {
          100: 'var(--color-pink-100)',
          200: 'var(--color-pink-200)',
          300: 'var(--color-pink-300)',
          400: 'var(--color-pink-400)',
          500: 'var(--color-pink-500)',
          600: 'var(--color-pink-600)',
          700: 'var(--color-pink-700)',
          800: 'var(--color-pink-800)',
          900: 'var(--color-pink-900)',
        },

        // External partner colors
        external: {
          'trustpilot-green': 'var(--color-external-trustpilot-green)',
          'klarna-pink': 'var(--color-external-klarna-pink)',
        },
      },

      backgroundColor: {
        // Body colors
        body: 'var(--color-body)',
        'body-light': 'var(--color-body-light)',
        'body-feint': 'var(--color-body-feint)',
        brand: 'var(--color-brand)',
        'brand-dark': 'var(--color-brand-dark)',
        grey: 'var(--color-grey)',
        white: 'var(--color-white)',
        'border-default': 'var(--color-border-default)',
        'border-dark': 'var(--color-border-dark)',
        overlay: 'var(--color-overlay)',
        'white-light': 'var(--color-white-light)',

        // Status colors
        negative: 'var(--color-negative)',
        'negative-bg': 'var(--color-negative-bg)',
        critical: 'var(--color-critical)',
        'critical-bg': 'var(--color-critical-bg)',
        positive: 'var(--color-positive)',
        'positive-bg': 'var(--color-positive-bg)',
        information: 'var(--color-information)',
        'information-bg': 'var(--color-information-bg)',

        // Mono colors
        mono: {
          '000': 'var(--color-mono-000)',
          100: 'var(--color-mono-100)',
          200: 'var(--color-mono-200)',
          300: 'var(--color-mono-300)',
          400: 'var(--color-mono-400)',
          500: 'var(--color-mono-500)',
          600: 'var(--color-mono-600)',
          700: 'var(--color-mono-700)',
          800: 'var(--color-mono-800)',
          900: 'var(--color-mono-900)',
          'tr-100': 'var(--color-mono-tr-100)',
          'tr-200': 'var(--color-mono-tr-200)',
          'tr-300': 'var(--color-mono-tr-300)',
          'tr-400': 'var(--color-mono-tr-400)',
          'tr-500': 'var(--color-mono-tr-500)',
          'tr-600': 'var(--color-mono-tr-600)',
          'tr-700': 'var(--color-mono-tr-700)',
          'tr-800': 'var(--color-mono-tr-800)',
          'tr-900': 'var(--color-mono-tr-900)',
        },

        // Blue colors
        blue: {
          100: 'var(--color-blue-100)',
          200: 'var(--color-blue-200)',
          300: 'var(--color-blue-300)',
          400: 'var(--color-blue-400)',
          500: 'var(--color-blue-500)',
          600: 'var(--color-blue-600)',
          700: 'var(--color-blue-700)',
          800: 'var(--color-blue-800)',
          900: 'var(--color-blue-900)',
        },

        // Red colors
        red: {
          100: 'var(--color-red-100)',
          200: 'var(--color-red-200)',
          300: 'var(--color-red-300)',
          400: 'var(--color-red-400)',
          500: 'var(--color-red-500)',
          600: 'var(--color-red-600)',
          700: 'var(--color-red-700)',
          800: 'var(--color-red-800)',
          900: 'var(--color-red-900)',
        },

        // Green colors
        green: {
          100: 'var(--color-green-100)',
          200: 'var(--color-green-200)',
          300: 'var(--color-green-300)',
          400: 'var(--color-green-400)',
          500: 'var(--color-green-500)',
          600: 'var(--color-green-600)',
          700: 'var(--color-green-700)',
          800: 'var(--color-green-800)',
          900: 'var(--color-green-900)',
        },

        // Yellow colors
        yellow: {
          100: 'var(--color-yellow-100)',
          200: 'var(--color-yellow-200)',
          300: 'var(--color-yellow-300)',
          400: 'var(--color-yellow-400)',
          500: 'var(--color-yellow-500)',
          600: 'var(--color-yellow-600)',
          700: 'var(--color-yellow-700)',
          800: 'var(--color-yellow-800)',
          900: 'var(--color-yellow-900)',
        },

        // Orange colors
        orange: {
          100: 'var(--color-orange-100)',
          200: 'var(--color-orange-200)',
          300: 'var(--color-orange-300)',
          400: 'var(--color-orange-400)',
          500: 'var(--color-orange-500)',
          600: 'var(--color-orange-600)',
          700: 'var(--color-orange-700)',
          800: 'var(--color-orange-800)',
          900: 'var(--color-orange-900)',
        },

        // Pink colors
        pink: {
          100: 'var(--color-pink-100)',
          200: 'var(--color-pink-200)',
          300: 'var(--color-pink-300)',
          400: 'var(--color-pink-400)',
          500: 'var(--color-pink-500)',
          600: 'var(--color-pink-600)',
          700: 'var(--color-pink-700)',
          800: 'var(--color-pink-800)',
          900: 'var(--color-pink-900)',
        },

        // External partner colors
        external: {
          'trustpilot-green': 'var(--color-external-trustpilot-green)',
          'klarna-pink': 'var(--color-external-klarna-pink)',
        },
      },

      borderRadius: {
        xs: 'var(--radius-xs)',
        '4xl': 'var(--radius-4xl)',
        standard: 'var(--radius-standard)',
      },

      lineHeight: {
        default: 'var(--leading-default)',
      },

      fontFamily: {
        sans: 'var(--font-sans)',
      },

      spacing: {
        'ds-xxxs': 'var(--spacing-ds-xxxs)', // 2px
        'ds-xxs': 'var(--spacing-ds-xxs)', // 4px
        'ds-xs': 'var(--spacing-ds-xs)', // 6px
        'ds-sm': 'var(--spacing-ds-sm)', // 8px
        'ds-ms': 'var(--spacing-ds-ms)', // 12px
        'ds-md': 'var(--spacing-ds-md)', // 16px
        'ds-ml': 'var(--spacing-ds-ml)', // 24px
        'ds-lg': 'var(--spacing-ds-lg)', // 32px
        'ds-xl': 'var(--spacing-ds-xl)', // 48px
        'ds-xxl': 'var(--spacing-ds-xxl)', // 64px
        'ds-xxxl': 'var(--spacing-ds-xxxl)', // 96px
      },
    },
  },
};
